exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header[data-v-ca6fc19c]{position:fixed;z-index:99;background-color:#fff;width:100%;top:0;left:0}.control[data-v-ca6fc19c]{line-height:11.73333vw;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:nowrap;flex-wrap:nowrap;font-size:4.8vw;color:#333;font-weight:700}.top[data-v-ca6fc19c]{height:5.33333vw;background-color:#f2f2f2}.left[data-v-ca6fc19c]{width:4vw;height:4vw;margin-left:4vw}.right[data-v-ca6fc19c]{width:4.8vw;height:1.06667vw;margin-right:4vw}", ""]);

// exports
